import styled, { keyframes } from 'styled-components';
import { border1, whitesmoke } from 'utils/style/colors';

export const TASK_CHIP_TRANSITION_CLASS_NAME = 'task-chip';

const fadeOutTaskChip = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
}`;

const fadeInTaskChip = keyframes`
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
}`;
interface TaskFilePickerChipProps {
  large: boolean;
}
export const TaskFilePickerChip = styled('span')<TaskFilePickerChipProps>`
  align-items: center;
  border-radius: 2rem;
  ${({ large }) => !large && `${border1};   background-color: ${whitesmoke};`}
  color: #696969;
  cursor: pointer;
  display: inline-flex;
  // font-size: ${({ large }) => (large ? '1.5rem' : '0.8rem')};
  font-weight: 500;
  line-height: 1.2rem;
  margin: 0.2rem 0 0.2rem 0.5rem;
  min-width: 6rem;
  overflow: hidden;
  padding: 0.2rem;
  transform: translate3d(0, 0, 0);
  cursor: pointer;
  transition:
    300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  user-select: none;
  &.${TASK_CHIP_TRANSITION_CLASS_NAME}-enter {
    animation: ${fadeInTaskChip} 0.3s ease;
  }
  &.${TASK_CHIP_TRANSITION_CLASS_NAME}-exit {
    animation: ${fadeOutTaskChip} 0.3s ease;
  }

  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-tap-highlight-color: transparent;
  :hover {
    background-color: #e0e0e0;
  }
  ::after {
    background-image: radial-gradient(
      circle,
      var(--exact-white) 10%,
      transparent 10.01%
    );
    background-position: 50%;
    background-repeat: no-repeat;
    content: '';
    display: block;
    height: 100%;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    transform: scale(10, 10);
    transition:
      transform 0.5s,
      opacity 1s;
    width: 100%;
  }
  :active {
    ::after {
      opacity: 0.4;
      transform: scale(0, 0);
      transition: 0s;
    }
  }
`;

export const TaskFileType = styled('span')`
  align-items: center;
  color: #616161;
  display: inline-flex;
  flex: none;
  justify-content: center;
  margin-left: 0.4rem;
  margin-right: 0.2rem;
`;

export const RemoveTaskFileIcon = styled('span')`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  border-radius: 50%;
  color: ${whitesmoke};
  display: inline-flex;
  height: 1.3rem;
  justify-content: center;
  width: 1.3rem;
  :hover {
    background-color: rgba(0, 0, 0, 0.35);
  }
`;

export const LoadingTaskFileIcon = styled('span')`
  align-items: center;
  display: inline-flex;
  height: 1.3rem;
  justify-content: center;
  width: 1.3rem;
`;

export const TaskFileName = styled('span')`
  color: rgba(0, 0, 0, 0.87);
  display: inline-flex;
  line-height: normal;
  flex: 1;
  font-weight: 400;
  margin-left: 1rem;
  word-break: break-word;
`;
